import { render, staticRenderFns } from "./detail_params.vue?vue&type=template&id=7afaf6cd&scoped=true"
import script from "./detail_params.vue?vue&type=script&lang=js"
export * from "./detail_params.vue?vue&type=script&lang=js"
import style0 from "./detail_params.vue?vue&type=style&index=0&id=7afaf6cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afaf6cd",
  null
  
)

export default component.exports